import { AuthState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: AuthState = {
  resetPasswordPrompt: '',
  passwordError: '',
  forgotEmailLogin: '',
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
